import { uniq } from 'lodash';

import { ComboField } from '~/components/form';
import { FilterDrawer } from '~/components/ui';
import { joinValues, splitValues } from '~/lib/listParams';
import type { ServiceRow } from '~/components/Constants/serviceConstants';

/** The drawer's fields: the URL key (also the service field it matches) and its label. */
export const SERVICE_FILTER_FIELDS = [
  { param: 'health', title: 'Health' },
  { param: 'image', title: 'Image' },
  { param: 'name', title: 'Name' },
  { param: 'serviceName', title: 'Service name' },
  { param: 'host', title: 'Host' },
  { param: 'status', title: 'Status' },
] as const;

type ServiceFilters = Record<string, string>;

interface ServicesDrawerProps {
  open: boolean;
  onClose: () => void;
  /** The applied filters by URL key; each is a `joinValues` list. */
  value: ServiceFilters;
  onApply: (filters: ServiceFilters) => void;
  onClear: () => void;
  rows: ServiceRow[];
}

export default function ServicesDrawer({
  open,
  onClose,
  value,
  onApply,
  onClear,
  rows,
}: ServicesDrawerProps) {
  return (
    <FilterDrawer<ServiceFilters>
      open={open}
      onClose={onClose}
      value={value}
      onApply={onApply}
      onClear={onClear}
      testId="services-filter-drawer"
    >
      {(draft, patch) =>
        SERVICE_FILTER_FIELDS.map(({ param, title }) => (
          <ComboField
            key={param}
            id={`service-filter-${param}`}
            label={title}
            isMulti
            selectAll
            value={splitValues(draft[param])}
            onChange={(values) => patch({ [param]: joinValues(values) })}
            options={uniq(rows.map((row) => String(row[param] ?? '')).filter(Boolean)).map(
              (option) => ({
                label: option,
                value: option,
              }),
            )}
          />
        ))
      }
    </FilterDrawer>
  );
}
